import { cn } from '@repo/lib/cn';
import { pluralize } from '@repo/lib/pluralize';

import type { GradeScheme } from './gradeScale.types';

function formatGradeCount(count: number): string {
  return `${count} ${pluralize(count, { one: 'ocena', few: 'oceny', many: 'ocen' })}`;
}

export interface GradeScaleSchemeListProps {
  schemes: GradeScheme[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

export function GradeScaleSchemeList(gradeScaleSchemeListProps: GradeScaleSchemeListProps) {
  const { schemes, selectedIndex, onSelect } = gradeScaleSchemeListProps;

  return (
    <div className="flex flex-col gap-3">
      {schemes.map((scheme, index) => {
        const isSelected: boolean = index === selectedIndex;
        return (
          <button
            key={scheme.name}
            type="button"
            onClick={() => onSelect(index)}
            className={cn(
              'outline-focus-ring flex cursor-pointer flex-col rounded-lg border px-3 py-2.5 text-left outline-0 transition-colors focus-visible:outline-3',
              isSelected ? 'border-border-primary bg-card shadow-sm' : 'border-border-secondary bg-background hover:bg-accent'
            )}
          >
            <span className="text-foreground truncate text-sm font-medium">{scheme.name}</span>
            <span className="text-muted-foreground truncate text-xs">{formatGradeCount(scheme.bands.length)}</span>
          </button>
        );
      })}
    </div>
  );
}
